import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getFormalizedZipState = (state: RootState) => state.formalizedZips;

export const formalizedZipSelectors = {
  getFormalizedZips: createSelector(
    getFormalizedZipState,
    (state) => state.formalizedZips,
  ),

  getFormalizedZipsLoading: createSelector(
    getFormalizedZipState,
    (state) => state.isLoading,
  ),

  getFormalizedZipDetail: createSelector(
    getFormalizedZipState,
    (state) => state.formalizedZipDetail.data,
  ),

  getFormalizedZipDetailLoading: createSelector(
    getFormalizedZipState,
    (state) => state.formalizedZipDetail.isLoading,
  ),

  // Алиасы для совместимости
  selectFormalizedZipData: createSelector(
    getFormalizedZipState,
    (state) => state.formalizedZips,
  ),

  selectFormalizedZipLoading: createSelector(
    getFormalizedZipState,
    (state) => state.isLoading,
  ),
};
